import { render, staticRenderFns } from "./AlertListing.vue?vue&type=template&id=4fab9859"
import script from "./AlertListing.vue?vue&type=script&lang=js"
export * from "./AlertListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports